import { render } from "./ServicesComp.vue?vue&type=template&id=a7717c98"
import script from "./ServicesComp.vue?vue&type=script&lang=js"
export * from "./ServicesComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__